import PropTypes from 'prop-types';
import classes from './actions.module.css';

const Actions = (props) => {
  const { children } = props;

  return (
    <div className={classes.actions}>
      {children}
    </div>
  );
};

Actions.propTypes = { children: PropTypes.any };

export default Actions;
